import { createPortal } from "react-dom";
import React from "react";
import { BannerWidget } from "@tkww/ads-content-component-fashion-stylematch";

class QuizBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { animation: undefined, isVisible: false };
    this.handleLocalStorageChange = this.handleLocalStorageChange.bind(this);
    this.branchIoObserver = React.createRef();
    this.branchIoIframe = React.createRef();
  }

  componentDidMount() {
    if (typeof window === "undefined") return;

    const observer = new MutationObserver((entries, observer) => {
      const branchBanner = entries.filter(
        (entry) => entry?.target?.id === "branch-banner-iframe"
      );

      if (branchBanner.length && branchBanner[0]?.target) {
        this.branchIoIframe.current = branchBanner[0]?.target;
        branchBanner[0].target.style.display = "none";
        observer.disconnect();
      }
    });
    this.branchIoObserver.current = observer;

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    let dismissCount = parseInt(
      localStorage.getItem("fashion_stylemach_banner_dismissed") || "0",
      10
    );

    if (dismissCount >= 2) {
      observer.disconnect();
      this.setState({ animation: "hide", isVisible: false });
      return;
    }

    const quizPending = JSON.parse(
      localStorage.getItem("fashion_stylematch_quiz_pending")
    );
    const modalDismissed = JSON.parse(
      localStorage.getItem("fashion_stylematch_modal_dismissed")
    );
    if (quizPending || modalDismissed) {
      this.setState({ animation: "show", isVisible: true });
    }

    window.addEventListener(
      "localStorageChanged",
      this.handleLocalStorageChange
    );
  }

  componentWillUnmount() {
    this.branchIoObserver.current.disconnect();
    window.removeEventListener(
      "localStorageChanged",
      this.handleLocalStorageChange
    );
    return;
  }

  handleLocalStorageChange = () => {
    this.setState({ animation: "show", isVisible: true });
  };

  handleClose = () => {
    if (this.branchIoIframe.current) {
      this.branchIoIframe.current.style.display = "block";
    }
    let dismissCount = parseInt(
      localStorage.getItem("fashion_stylemach_banner_dismissed") || "0",
      10
    );
    dismissCount += 1;
    localStorage.setItem("fashion_stylemach_banner_dismissed", dismissCount);
    window.dispatchEvent(new Event("localStorageChanged"));

    this.setState({ animation: "hide", isVisible: false });
  };

  render() {
    if (this.props.facadeProduct !== "WeddingDress") {
      return null;
    }

    const quizCompleted = JSON.parse(
      localStorage.getItem("fashion_stylematch_quiz_completed")
    );
    if (quizCompleted) {
      return false;
    }

    const portalNode = document.getElementById(
      "stylematch-banner-widget-container"
    );
    if (!portalNode) {
      return null;
    }
    if (localStorage.getItem("fashion_stylematch_quiz_complete")) {
      return null;
    }
    return createPortal(
      <BannerWidget
        handleClose={() => this.handleClose()}
        animation={this.state.animation}
        isVisibile={this.state.isVisible}
      />,
      portalNode
    );
  }
}

export default QuizBanner;
